const appIcons = {
  // Koachify
  koachifyexploreIcon: '\ue902',
  mycoursesIcon: '\ue907',
  liveclassesIcon: '\ue903',
  mysessionsIcon: '\ue904',

  // Eventify
  eventifyExploreIcon: '\ue905',
  sessionsIcon: '\ue909',
  exhibitorsIcon: '\ue911',
  sponsorsIcon: '\ue916',
  speakersIcon: '\ue915',
  myagendaIcon: '\ue910',
  surveyIcon: '\ue917',
  galleryIcon: '\ue912',
  communityIcon: '\ue900',
  mapsIcon: '\ue913',
  newsIcon: '\ue914',
  bookmarksIcon: '\ue904',
  ticketIcon: '\ue90b',
  socialIcon: '\ue920',
  gamificationIcon: '\ue91f',
  notesIcon: '\ue921',
  webviewIcon: '\ue922',
  profileIcon: '\ue908',
  attendeesIcon: '\ue918',
  chatIcon: '\ue901',
  pollsIcon: '\ue906',
  qrScanIcon: '\ue932',

  // utility
  globeIcon: '\ue941',
  rightChevronArrow: '\ue937',
  leftChevronArrow: '\ue93d',
  copy: '\ue93a',
  check: '\ue93b',
  sendIcon: '\ue93c',
  camera: '\ue93f',
  doubleCheckIcon: '\ue93e',
  glassHours: '\ue940',
  fillPin: '\ue939',
  menuHamburgerIcon: '\ue944',
  imageUploadIcon: '\ue948',
  threeDotVerticalIcon: '\ue949',
  likeIcon: '\ue94a',
  loginIcon: '\ue92f',
  logoutIcon: '\ue930',
  searchIcon: '\ue931',
  syncIcon: '\ue933',
  qrCodeIcon: '\ue956',

  // promo
  locationPinIcon: '\ue934',
  scheduleIcon: '\ue935',

  // Icons
  downloadIcon: '\ue90a',
  fileDefaultIcon: '\ue90c',
  fileDocumentIcon: '\ue90d',
  fileImageIcon: '\ue90e',
  uploaderIcon: '\ue90f',
  messageIcon: '\ue943',
  letsMeetIcon: '\ue942',
  envelopIcon: '\ue91c',
  bookmarkOutlineIcon: '\ue91e',
  circleTickIcon: '\ue91b',
  calenderDarkIcon: '\ue909',
  calenderIcon: '\ue910',
  photoIcon: '\ue912',
  crossCircleIcon: '\uea0d',
  blockedIcon: '\uea0e',
  trashIcon: '\ue906',
  viewEyeIcon: '\ue924',
  bellIcon: '\ue925',
  timerIcon: '\ue926',
  lockerIcon: '\ue927',
  eventGuideIcon: '\ue902',
  tiltedAttachmentIcon: '\ue945',
  pdfIcon: '\ue946',
  gearIcon: '\ue947',
  starIcon: '\ue923',
  thumbsUpIcon: '\ue928',
  invertedTrashIcon: '\ue929',
  crossIcon: '\ue92a',
  briefcaseIcon: '\ue92b',
  officeIcon: '\ue92c',
  sessionCalenderIcon: '\ue92d',
  videoCamIcon: '\ue936',
  lightningBolt: '\ue938',
  trophySolidIcon: '\ue94b',
  repeatIcon: '\ue94e',
  arrowLeftIcon: '\ue94f',
  clockIcon: '\ue950',
  filterConeLineIcon: '\ue951',
  mutualInterestIcon: '\ue952',
  settingsGearIcon: '\ue953',
  settingsSliderIcon: '\ue954',
  listIcon: '\ue955',
  linkChainIcon: '\ue957',

  // layout structure
  homeIcon: '\ue92e',
  gridLayout: '\ue94c',
  listLayout: '\ue94d',
  filterIcon: '\ue91d',

  // ================ Other images
  eventifyFavIcon:
    'https://uploads-ssl.webflow.com/61cee5eb4d566d3471eca114/6225b2994858c92ff025b7b4_Eventify%20Favicon.png',
  cookieIcon:
    'https://uploads-ssl.webflow.com/61cee5eb4d566d3471eca114/64955c7ccb95688383bf042d_cookie-webflow-cloneable-template-brix-templates.svg'
};

export default appIcons;
